import "./App.css";
import { Header } from "../components/common/Header";
import { HeaderNav, HeaderNavFAQ, Footer } from "../components/common/index";
import { Route, Routes, Navigate } from "react-router-dom";
import { LoginStageContextProvider, cognitoUserAttributes, useAccountContext, useUserDataContext } from "../contexts/index";
import { useEffect } from "react";
import FAQ from "../pages/FAQ";
import MyItems from "../pages/MyItems";
import ListsRoute from "../features/lists/ListsRoute";
import Home from "../pages/Home";
import Privacy from "../pages/Privacy";
import Terms from "../pages/TermsAndConditions";
import Blog from "../pages/Blog";
import ProviderBioPage from "../pages/ProviderBioPage";
import { MyAccount } from "../components/common/Header/MyAccount";
import { CheckoutPopup } from "../components/modals/index";



function App() {
  const {
    loggedInUserCognitoIdToken,
    setLoggedInUserCognitoIdToken,
    setUserCognitoAttrubutes,
    myAccountOpen,
  } = useAccountContext();

  const { multiSelectMode, checkoutPopupOpen } = useUserDataContext();

  useEffect(() => {
    if (loggedInUserCognitoIdToken == "") {
      const attributesString = window.localStorage.getItem(
        "UserCognitoAttrubutes"
      );
      if (attributesString != null) {
        const attributes: cognitoUserAttributes = JSON.parse(
          attributesString
        ) as cognitoUserAttributes;
        const id = window.localStorage.getItem("CognitoIdToken");
        setUserCognitoAttrubutes(attributes);
        if (id != null) {
          setLoggedInUserCognitoIdToken(id);
        }
      }
    }
  }, []);
  return (
    <>
      <LoginStageContextProvider>
        <Header />
        {myAccountOpen && <MyAccount />}
        {checkoutPopupOpen && <CheckoutPopup />}
        <div className="container">
          <Routes>
          <Route
            path="/"
            element={
              <>
                <HeaderNavFAQ />
                <Home />
                <Footer/>
              </>
            }
          />
          <Route
            path="/Home"
            element={
              <>
                <HeaderNavFAQ />
                <Home />
                <Footer/>
              </>
            }
          />
          <Route
            path="/FAQ"
            element={
              <>
                <HeaderNavFAQ />
                <FAQ />
                <Footer/>
              </>
            }
          />
          <Route
            path="/MyItems"
            element={
              <div className="route-wrapper">
                <HeaderNav />
                <div className="route-content">
                  <MyItems alrt={null}  />
                </div>
                {!multiSelectMode && (
                  <>
                    <br/>
                    <br/>
                    <br/>
                    <Footer/>
                  </>
                )}
              </div>
            }
          />
          <Route
            path="/success"
            element={
              <div className="route-wrapper">
                <HeaderNav />
                <div className="route-content">
                  <MyItems alrt={"success"} />
                </div>
                {!multiSelectMode && (
                  <>
                    <br/>
                    <br/>
                    <br/>
                    <Footer/>
                  </>
                )}
              </div>
            }
          />
          <Route
            path="/cancel"
            element={
              <div className="route-wrapper">
                <HeaderNav />
                <div className="route-content">
                  <MyItems alrt={"cancel"} />
                </div>
                {!multiSelectMode && (
                  <>
                    <br/>
                    <br/>
                    <br/>
                    <Footer/>
                  </>
                )}
              </div>
            }
          />
          <Route
            path="/Privacy"
            element={
              <>
                <HeaderNavFAQ />
                <Privacy/>
                <Footer/>
              </>
            }
          />
          <Route
            path="/Terms"
            element={
              <>
                <HeaderNavFAQ />
                <Terms/>
                <Footer/>
              </>
            }
          />
          <Route
            path="/Lists"
            element={<ListsRoute />}
          />
          <Route
            path="/Blog"
            element={
              <>
                <HeaderNavFAQ />
                <Blog/>
                <Footer/>
              </>
            }
          />
          <Route
            path="/:username"
            element={
              <>
                <HeaderNavFAQ />
                <ProviderBioPage/>
                <Footer/>
              </>
            }
          />
          {/* Catch-all route - redirects any unknown paths to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </LoginStageContextProvider>
    </>
  );
}

export default App;
